export const generateOptionsArray = ({ values, additionalOption }) => {
    const array = values.map(value => ({ label: value, value }));
    return [additionalOption].concat(array);
};
